import { FC, useEffect } from 'react';
import { Box } from 'enova-frontend-components';

import useBuildingFilter from '../../../../../hooks/useBuildingFilter';
import { MainScreenTab } from '../../../../../utils/navigation';

import BuildingListItem from './buildingListItem';
import { Filters } from './filters';
import { BuildingListError, BuildingListLoader, GridWrapper } from './components';
import { BuildingListEmptyState } from './buildingListEmptyState';

interface Props {
  tab: MainScreenTab;
}

const BuildingList: FC<Props> = ({ tab }) => {
  const { buildingList } = useBuildingFilter();

  useEffect(() => {
    buildingList?.refreshBuildings?.();
  }, [tab]);

  if (buildingList?.buildingsLoading) {
    return <BuildingListLoader />;
  }

  if (buildingList?.buildingsHasError) {
    return <BuildingListError error={buildingList.buildingsError} />;
  }

  const buildings = buildingList?.buildings;

  if (!buildings || buildings.length === 0) {
    return (
      <Box display="flex" flexDirection="column" gap={2}>
        <Filters />
        <BuildingListEmptyState />
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" mt={3}>
      <GridWrapper>
        <Filters />
        {buildings?.map((building) => (
          <BuildingListItem
            key={building.energiObjektId}
            displayOptions={tab !== MainScreenTab.BUILDINGS}
            building={building}
          />
        ))}
      </GridWrapper>
    </Box>
  );
};

export default BuildingList;
